import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import styled from 'styled-components';
import { rgba } from 'polished';
import { connect } from 'react-redux';
import { color, toCurrency } from '@deerplusofficial/pos-helper';
import { ButtonBase as Button } from '@deerplusofficial/pos-components';
import actions from '../../actions';
import withCartProps from '../../assist/withCartProps';
import CartPreOrderStatus from './CartPreOrderStatus';
import PriceRow from './PriceRow';
import ItemRow from './ItemRow';

const sortItems = fp.compose(
  fp.reverse,
  fp.entries
);

const List = styled.div`
  flex: 1 1;
  overflow: auto;
  padding: 25px;
  border-bottom: 1px solid ${color.border};
`;

const InputTotalPrice = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 25px;
  margin-bottom: 12px;
  font-size: 16px;
  border-bottom: 1px solid ${color.border};
`;

const InputTotalPriceEditor = styled.input`
  margin-left: auto;
  text-align: right;
  outline: none;
  border: 0;
  &:focus {
    background-color: ${rgba(color.border, 0.5)};
  }
`;

const InputTotalPriceValue = styled(Button)`
  flex-grow: 1;
  text-align: right;
  color: ${color.text.price};
`;

const Subtotal = styled.div`
  padding: 25px;
`;

class CartItemList extends React.PureComponent {
  static propTypes = {
    cart: PropTypes.shape(),
    order: PropTypes.shape(),
    orderDiscount: PropTypes.shape(),
    readonly: PropTypes.bool,
    customPriceEnabled: PropTypes.bool,
    toggleCustomPrice: PropTypes.func,
  };

  static defaultProps = {
    cart: {},
    order: {},
    orderDiscount: {},
    readonly: false,
    customPriceEnabled: false,
    toggleCustomPrice: _.identity,
  };

  onInputTotalPriceChange = e => {
    const customPrice = Number(e.target.value);

    if (_.isNaN(customPrice)) return;

    this.props.editCustomPrice(customPrice);
  };

  onInputTotalPriceFinish = ({ key }) => {
    if (key !== 'Enter') return;

    this.props.toggleCustomPrice();
  };

  renderItems = () => {
    const { cart, readonly } = this.props;

    return _.map(sortItems(cart.items), ([id, props]) => (
      <ItemRow key={id} id={id} disabled={readonly} {...props} />
    ));
  };

  render() {
    const {
      cart,
      orderDiscount,
      readonly,
      customPriceEnabled,
      toggleCustomPrice,
      tax,
      totalDiscount,
      preOrderId,
      order: { customPrice },
    } = this.props;

    return (
      <React.Fragment>
        {preOrderId && <CartPreOrderStatus />}
        <List>
          {_.size(cart.items) ? (
            this.renderItems()
          ) : (
            <InputTotalPrice>
              <div>手動輸入訂單金額</div>
              {customPriceEnabled ? (
                <InputTotalPriceEditor
                  autoFocus
                  type="text"
                  value={customPrice === 0 ? '' : customPrice}
                  size={_.size(String(customPrice)) + 1}
                  onChange={this.onInputTotalPriceChange}
                  onBlur={toggleCustomPrice}
                  onKeyPress={this.onInputTotalPriceFinish}
                />
              ) : (
                <InputTotalPriceValue
                  disabled={readonly}
                  onClick={toggleCustomPrice}
                >
                  {toCurrency(customPrice)}
                </InputTotalPriceValue>
              )}
            </InputTotalPrice>
          )}
          {_.size(orderDiscount) > 0 && (
            <PriceRow
              name={orderDiscount.name}
              value={-orderDiscount.discountValue}
            />
          )}
        </List>
        <Subtotal>
          {totalDiscount > 0 && (
            <PriceRow name="總折扣金額" value={-totalDiscount} />
          )}
          <PriceRow {...tax} />
        </Subtotal>
      </React.Fragment>
    );
  }
}

const {
  edit: editCustomPrice,
  toggle: toggleCustomPrice,
} = actions.order.customPrice;

export default fp.compose(
  withCartProps(),
  connect(
    ({ order: { customPriceEnabled }, preOrder: { id } }) => ({
      customPriceEnabled,
      preOrderId: id,
    }),
    {
      editCustomPrice,
      toggleCustomPrice,
    }
  )
)(CartItemList);



// WEBPACK FOOTER //
// ./src/components/Cart/CartItemList.js